// extracted by mini-css-extract-plugin
export var wordContainer = "_r3-0";